<template>
  <fieldset class="space-y-3 border-b border-base-300 pb-6 last:border-none last:pb-0 mt-8 first:mt-0">
    <legend :id="`${group.id}-label`" class="text-lg sm:text-xl font-bold flex items-center gap-2 text-base-content">
      <span>{{ $t(group.title) }}</span>
      <span v-if="group.tooltip" class="tooltip tooltip-info cursor-pointer text-sm" :data-tip="$t(group.tooltip)">ℹ️</span>
    </legend>

    <p v-if="group.subtitle" class="text-sm text-gray-600 mt-1">{{ $t(group.subtitle) }}</p>

    <div
      :id="group.id"
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5"
      :aria-labelledby="`${group.id}-label`">
      <template v-for="opt in group.options" :key="opt.id">
        <PlanOptionButton
          v-memo="[opt.isSelected, opt.isRecommended, opt.alwaysSelected]"
          :displayName="opt.id === 'domain_managed' && domainStore.domainName ? `${$t(opt.displayName)}: ${domainStore.domainName}` : $t(opt.displayName)"
          :rationale="$t(opt.rationale)"
          :price="opt.price"
          :billingLabel="opt.billingLabel"
          :isPopular="opt.isPopular"
          :alwaysSelected="opt.alwaysSelected"
          :isRecommended="opt.isRecommended"
          :checked="opt.isSelected"
          @click="$emit('toggle', opt.id)" />
      </template>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import type { PlanOptionGroup } from "@/features/planSelection/models/PlanOptionGroup";
import PlanOptionButton from "@/features/planSelection/components/PlanOptionButton.vue";
import { PlanOption } from "@/features/planSelection/models/PlanOption";
import { useDomainSelectionStore } from "@/features/domain-checker-input/stores/useDomainSelectionStore";

const domainStore = useDomainSelectionStore();
defineProps<{
  group: PlanOptionGroup & {
    options: Array<
      PlanOption & {
        isSelected: boolean;
        isRecommended: boolean;
        isPopular: boolean;
        alwaysSelected: boolean;
      }
    >;
  };
}>();

const emit = defineEmits<{
  (e: "toggle", optionId: string): void;
}>();
</script>
